import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  CategoriaReporte,
} from '@app/shared';

@Injectable()
export class ManagementReportsDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Consulta de todas las categorias de reportes
   *
   * @returns {Observable<CategoriaReporte[]>}
   * @memberof ManagementReportsDataService
   */
  getCategoryReport(): Observable<CategoriaReporte[]> {
    return new Observable(obs => {
      this.http.get<CategoriaReporte[]>(this.api.get('categoryReports')).subscribe(
        categorys => {
          if (categorys && categorys.length) {
            categorys.sort((a, b) => a.id - b.id);
          }
          obs.next(categorys);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Agrega una categoria de reporte al sistema
   *
   * @param {CategoriaReporte} data
   * @returns {Observable<boolean>}
   * @memberof ManagementReportsDataService
   */
  addCategoryReport(data: CategoriaReporte): Observable<boolean> {
    return new Observable(obs => {
      this.http.post<boolean>(this.api.get('categoryReports'), data).subscribe(
        resp => {
          this.toastr.success('Categoría creada con éxito', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Actualiza una categoria de reportes
   *
   * @param {CategoriaReporte} data
   * @param {number} idCategory
   * @returns {Observable<boolean>}
   * @memberof ManagementReportsDataService
   */
  updateCategoryReport(data: CategoriaReporte, idCategory: number): Observable<boolean> {
    return new Observable(obs => {
      this.http.put<boolean>(this.api.get('categoryReports', [idCategory]), data).subscribe(
        resp => {
          this.toastr.success('Categoría actualizada con éxito', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Elimina una categoria de reportes
   *
   * @param {number} idCategory
   * @returns {Observable<boolean>}
   * @memberof ManagementReportsDataService
   */
  deleteCategoryReport(idCategory: number): Observable<boolean> {
    return new Observable(obs => {
      this.http.delete<boolean>(this.api.get('categoryReports', [idCategory])).subscribe(
        resp => {
          this.toastr.success('Categoría eliminada con éxito', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/shared/management-reports.data.service.ts